import { BrowserRouter, Routes, Route } from 'react-router-dom'
import HomePage from './pages/HomePage'
import PaperDetail from './pages/PaperDetail'
import AdminPanel from './pages/AdminPanel'
import Visualizations from './pages/Visualizations'
import AnalyzePage from './pages/AnalyzePage'
import LearnTool from './pages/LearnTool'

// 使用相对路径，前后端同域名
export const API_BASE = ''

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/paper/:id" element={<PaperDetail />} />
        <Route path="/visualizations" element={<Visualizations />} />
        <Route path="/admin" element={<AdminPanel />} />
        <Route path="/analyze" element={<AnalyzePage />} />
        <Route path="/learn" element={<LearnTool />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
